import { render, staticRenderFns } from "./notification-detail.vue?vue&type=template&id=bec0c3f4&"
import script from "./notification-detail.vue?vue&type=script&lang=js&"
export * from "./notification-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports